require('./gitlabFangornConfig.js');



//////////////////
// WEBPACK FOOTER
// ./addons/gitlab/static/files.js
// module id = 761
// module chunks = 54